export const AUTH_FORGOT_PASSOWRD_MESSAGE =
  'In case you forgot your password please contact to your system administrator.'

export const MATCHING_EMAIL_MESSAGE =
  'If a matching email is found, reset instructions will be sent to your email.'

export const EMAIL_REQUIRED_MESSAGE = 'Please input your email!'
export const EMAIL_RULE_MESSAGE =
  'Allowed only latin letters, digits, dots, special chars!'
export const EMAIL_EXTRA_MESSAGE =
  'Email will be sent to you with the details to access your account again.'

export const LOGIN_REQUIRED_MESSAGE = 'Please input your login!'

export const PASSWORD_REQUIRED_MESSAGE = 'Please input your password!'
export const PASSWORD_INCORRECT_MESSAGE = 'Incorrect password.'
export const PASSWORD_NOT_EQUAL_MESSAGE = "Passwords aren't equal."

export const FIELD_REQUIRED_MESSAGE = 'Field is required.'
export const REFERRAL_NOTE_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 10000 symbols are allowed.'
export const FIVE_THOUSAND_SYMBOLS_LIMIT_MESSAGE =
  'Text cannot be longer than 5000 characters'
export const MEDIUM_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 127 symbols are allowed.'
export const LONG_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 255 symbols are allowed.'
export const CUSTOMINPUT_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 500 symbols are allowed.'
export const WRONG_FILE_FORMAT_MESSAGE = 'Wrong file format!'
export const WRONG_FILE_SIZE_MESSAGE = (maxSize = '') =>
  `Your file cannot be uploaded because it exceeds the size limit of ${maxSize}. Please choose a smaller file or reduce the file size and try again.`
export const PHONE_INVALID_MESSAGE = 'Phone number is invalid.'

export const DAYS_LEFT_MESSAGE =
  'Days left exclude today if measurement(s) were completed today.'

export const PATIENT_MOBILE_APP_MESSAGE =
  'The patient has Emmacare mobile app installed.'

export const ZIP_CODE_ERROR_MESSAGE = 'ZIP must contain 5 digits.'

export const INVALID_PHONE_NUMBER_MESSAGE = 'Phone number is invalid.'
export const PHONE_GENERATE_ERROR_MESSAGE =
  'Mobile phone number that starts with 000 cannot be set manually.'

export const EMAIL_REQUIREMENT_MESSAGE = 'Email is required'
export const INVALID_EMAIL_MESSAGE =
  'Allowed only latin letters, digits, dots, special chars!'
export const EMAIL_ERROR_MESSAGE = 'Invalid email value.'

export const DATE_IS_REQUIRED_MESSAGE = 'Date is required'
export const DIAGNOSIS_SELECT_MESSAGE = 'Select diagnosis from list.'

export const DISEASE_IS_REQUIRED_MESSAGE = 'Problem is required!'
export const CHANGE_PRIMARY_DISEASE_CONFIRM_MESSAGE = (
  newDis: string,
  oldDis: string
) => `Set ${newDis} as primary problem instead of ${oldDis}`

export const CHANGE_PRIMARY_DIAGNOSIS_CONFIRM_MESSAGE = (
  newDia: string,
  oldDia: string,
  isPrimary: boolean
) =>
  `Set ${newDia} as ${
    isPrimary ? 'primary' : 'secondary'
  } diagnosis instead of ${oldDia}`

export const NUMBER_SIX_DIGITS_RANGE_VALIDATION_MESSAGE =
  'Number should be in range 0-999999.'

export const INSURANCE_INFO_REFERRAL_MESSAGE =
  'Use this filter to search for referrals based on any insurance information they have.'

export const LINK_COPY_MESSAGE = 'Link copied to the clipboard.'
